<template>
  <div>
    <create-form></create-form>
  </div>
</template>
<script>
import CreateForm from "./CreateForm.vue";
export default {
  components: {
    CreateForm
  }
};
</script>
